import { render, staticRenderFns } from "./wTextarea.vue?vue&type=template&id=9b2cba36&scoped=true&"
import script from "./wTextarea.vue?vue&type=script&lang=js&"
export * from "./wTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2cba36",
  null
  
)

export default component.exports